import { Button, Text } from '@user-portal/wikr-components';
import {
    trackMainAppStoreClick,
    trackMainGooglePayClick,
    trackSimpleLoginPageLoad,
} from 'analytics/trackers/installApp';
import React, { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { getDeepLinkRequest } from 'store/deepLink/actions';
import { GET_DEEP_LINK } from 'store/deepLink/actionTypes';
import { selectDeepLink } from 'store/deepLink/selectors';
import { createProcessingSelector } from 'store/loading/selectors';
import { selectCurrentUser } from 'store/user/selectors';

import { useOneTrust } from 'services/OneTrust/useOneTrust';

import { useScreenLoadTracker, useSelector } from 'hooks';

import isMobile from 'helpers/isMobile';

import * as S from './AppDownloadMobileModule.styled';

export type Variant = 'male' | 'female';

function isVariant(value: string): value is Variant {
    return value === 'male' || value === 'female';
}

export const AppDownloadMobileModule = () => {
    useScreenLoadTracker(() => trackSimpleLoginPageLoad());

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const isLoading: boolean = useSelector(createProcessingSelector([GET_DEEP_LINK]));
    const deepLinkUrl = useSelector(selectDeepLink);
    const user = useSelector(selectCurrentUser);
    const { isBannerClosed } = useOneTrust({});

    const isIos = isMobile.iOS();
    const isAndroid = isMobile.android();

    useEffect(() => {
        if (!deepLinkUrl) dispatch(getDeepLinkRequest());
    }, [dispatch, deepLinkUrl]);

    const handleDownloadApp = () => {
        if (isAndroid) trackMainGooglePayClick();
        if (isIos) trackMainAppStoreClick();

        // Workaround for window.open method since it doesn't work for Safari browser
        Object.assign(document.createElement('a'), {
            target: '_blank',
            rel: 'noopener noreferrer',
            href: deepLinkUrl,
        }).click();
    };

    const variant: Variant = isVariant(user.gender) ? user.gender : 'male';

    return (
        <S.Container $variant={variant} $isCookieBannerVisible={!isBannerClosed}>
            <Text type="h5" center mb={12}>
                {t('main.appDownload.title')}
            </Text>
            <Text center mb={24} color="text-secondary" medium>
                <Trans
                    i18nKey="main.appDownload.subtitle"
                    values={{ email: user.email }}
                    components={{ bold: <S.Email /> }}
                />
            </Text>
            <Button isLoading={isLoading} onClick={handleDownloadApp}>
                {t('main.appDownload.button')}
            </Button>
        </S.Container>
    );
};
